<template>
  <div v-if="iconClass">
    <i :class="iconClass"></i>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      iconMappings: null
    };
  },
  computed: {
    iconClass() {
      return this.iconMappings ? this.iconMappings[this.icon] : null;
    }
  },
  created() {
    // Load the icon mappings from the JSON file in the src directory
    this.iconMappings = require('@/iconMappings.json');
  }
};
</script>
<style lang="scss" scoped>
svg {
  width: inherit;
  height: inherit;
  fill: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomIcon.vue